import Lottie from "lottie-react";
import animation from "./mobileLoading.json";
import "./Loading.scss";

const Loading = ({ isFull }: { isFull?: boolean }) => {
  return (
    <div className={`loading${isFull ? " full" : undefined}`}>
      <div className="overlay"></div>
      <Lottie
        className="lottie"
        animationData={animation}
        loop={true}
        autoPlay={true}
      />
    </div>
  );
};

export default Loading;
